var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jdi-content',{attrs:{"title":"Toolbar"}},[_c('jdi-status',{attrs:{"wip":""}}),_c('h3',[_vm._v("Example")]),_c('h2',[_vm._v("When to use")]),_c('h2',[_vm._v("Sub-Components")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }